import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LikeMindedState } from './store';

interface FilterSlice {
  language?: string;
  topic?: string;
  format?: string;
}

const initialState = {} as FilterSlice;

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<FilterSlice>) {
      const notEmptyFilterEntries = Object.entries({
        ...state,
        ...action.payload,
      }).filter(([key, value]) => Boolean(value));

      return Object.fromEntries(notEmptyFilterEntries);
    },
    resetFilters(state) {
      state = initialState;
    },
  },
});

export const filtersReducer = filtersSlice.reducer;
export const selectFilters = (state: LikeMindedState) => state.filters;
export const { setFilters, resetFilters } = filtersSlice.actions;
